<template>

    <div class="panel">

        <div class="panel-body">

            <el-row class="column-name" justify="start">
                <span>加分项</span>
                <div class="navbar-right" v-if="assessmentVersionDetail.status == 'DRAFT'">
                    <el-button v-if="canOper" type="info" plain size="minimum" @click="openNewAddsubConfDialog('add')">新增
                    </el-button>
                </div>
            </el-row>
            <el-table :data="addTableData" stripe style="width: 100%">
                <el-table-column prop="seq" style="" label="序号">
                </el-table-column>
                <el-table-column prop="desc" label="描述">
                </el-table-column>
                <el-table-column label="操作" v-if="assessmentVersionDetail.status == 'DRAFT'">
                    <template slot-scope="scope">
                        <el-button @click="tableModiFunc(scope.row, 'add')" v-if="canOper" type="text" size="small">
                            修改
                        </el-button>
                        <el-button @click="tableDelFunc(scope.row, 'add')" v-if="canOper" type="text" size="small">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-row class="column-name" justify="start">
                <span>减分项</span>
                <div class="navbar-right" v-if="assessmentVersionDetail.status == 'DRAFT'">
                    <el-button v-if="canOper" type="info" plain size="minimum" @click="openNewAddsubConfDialog('sub')">新增
                    </el-button>
                </div>
            </el-row>
            <el-table :data="subTableData" stripe style="width: 100%">
                <el-table-column prop="seq" style="" label="序号">
                </el-table-column>
                <el-table-column prop="desc" label="描述">
                </el-table-column>
                <el-table-column label="操作" v-if="assessmentVersionDetail.status == 'DRAFT'">
                    <template slot-scope="scope">
                        <el-button @click="tableModiFunc(scope.row, 'sub')" v-if="canOper" type="text" size="small">
                            修改
                        </el-button>
                        <el-button @click="tableDelFunc(scope.row, 'sub')" v-if="canOper" type="text" size="small">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>

        <addsub-conf-dialog ref="addsubConfDialogRef"
                            :addsubConfInfo="addsubConfInfo"
                            :addSubconfDialogVisible.sync="addSubconfDialogVisible"
                            @afterSavedAddSubConfRecord="afterSavedAddSubConfRecord"></addsub-conf-dialog>

    </div>

</template>

<script>

    import addsubConfDialog from "../addsubconf/addsubConfDialog";
    import AssessmentServer from "../../../api/assessment";
    import {createNamespacedHelpers} from "vuex";

    import {ASSESSMENT_PERMISSION} from '../assessment_common'
    import {formatDate} from "element-ui/lib/utils/date-util";

    const assessmentConfNSHelper = createNamespacedHelpers("assessment/assessmentConf");
    const assessmentVersionNSHelper = createNamespacedHelpers("assessment/assessmentVersion");

    export default {
        name: "addsubConfigTable",

        components: {
            addsubConfDialog,
        },

        data() {
            return {

                addSubconfDialogVisible: false,

                addTableData: [],
                subTableData: [],

                addsubConfInfo: {
                    config: '',
                    seq: '',
                    type: '',
                    changeby: '',
                    changedate: formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                },

                canOper: true,

            }
        },

        methods: {

            openNewAddsubConfDialog(type) {
                AssessmentServer.addsubConf.seq({
                    type: type,
                    config: this.rootAssessmentConfid,
                }).then(res => {
                    this.addsubConfInfo = {
                        config: this.rootAssessmentConfid,
                        seq: res.data,
                        type: type,
                        changeby: localStorage.getItem('realname'),
                        changedate: formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    };
                    this.addSubconfDialogVisible = true;
                    this.$refs.addsubConfDialogRef.$refs.form_conf_record.clearValidate();
                });
            },

            afterSavedAddSubConfRecord(params) {
                this.queryTable(this.rootAssessmentConfid);
                this.$emit("afterSavedAddSubConfRecord", params);
            },

            queryTable(rootAssessmentConfid) {
                AssessmentServer.addsubConf.list({config: rootAssessmentConfid}).then(res => {
                    if (res.data.code == 200) {
                        this.addTableData = res.data.data.filter(e => {
                            return e.type == 'add';
                        });
                        this.subTableData = res.data.data.filter(e => {
                            return e.type == 'sub';
                        });
                    }
                });
            },

            tableModiFunc(row, type) {
                AssessmentServer.addsubConf.get(row.id).then(res => {
                    if (res.data.code == 200) {
                        this.addsubConfInfo = res.data.data;
                        this.addsubConfInfo.type = type;
                        this.addsubConfInfo.changeby = localStorage.getItem('realname');
                        this.addsubConfInfo.changedate = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
                        this.addSubconfDialogVisible = true;

                        try {
                            this.$refs.addsubConfDialogRef.$refs.form_conf_record.clearValidate();
                        } catch (e) {
                            console.log(e);
                        }

                    }
                })
            },

            tableDelFunc(row, type) {
                this.$confirm('删除此加、减分项, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    AssessmentServer.addsubConf.delete(row.id).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success("删除加、减分项成功");
                            this.queryTable(row.config);
                            this.$emit("afterSavedAddSubConfRecord");
                        } else {
                            this.$message.error("删除加、减分项失败:" + res.data.message);
                        }
                    });
                }).catch(() => {
                    console.log('已取消删除');
                });
            },

        },


        computed: {

            ...assessmentConfNSHelper.mapGetters(['assessmentTreeInfo']),

            ...assessmentVersionNSHelper.mapGetters(['assessmentVersionDetail']),

            //分项评分树根ID
            rootAssessmentConfid() {
                if (this.assessmentTreeInfo != null && this.assessmentTreeInfo.length != 0) {
                    return this.assessmentTreeInfo[0].id;
                }
            },

        },

        watch: {

            rootAssessmentConfid: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal != null) {
                        this.queryTable(newVal);
                    }
                }
            },

        },


        mounted() {
            this.canOper = this.hasPermission(ASSESSMENT_PERMISSION);
        },

    }
</script>

<style scoped>

</style>